<template>
    <content-with-side-menu>
        <template #side-menu>
            <mq-layout mq="tablet+">
                <dashboard-side-menu class="is-hidden-mobile" />
            </mq-layout>
        </template>
        <template #main-content>
            <mq-layout mq="mobile">
                <dashboard-top-menu />
            </mq-layout>
            <router-view></router-view>
        </template>
    </content-with-side-menu>
</template>

<script>
import DashboardSideMenu from '@/components/DashboardSideMenu';
import DashboardTopMenu from '@/components/DashboardTopMenu';
import ContentWithSideMenu from '@/layouts/ContentWithSideMenu';
export default {
    components: {
        DashboardSideMenu,
        DashboardTopMenu,
        ContentWithSideMenu,
    },
    data() {
        return {};
    },
    mounted() {
        this.$store.dispatch('fetchMyCommunities'); //force communities fetch to render side menu option
    },
    metaInfo() {
        return {
            title: 'Dashboard',
            titleTemplate: '%s - Labylok',
        };
    },
    methods: {},
};
</script>

<style scoped lang="scss"></style>
